import React from 'react'

import { Col, Divider, Row } from 'antd'

import { ProductIds } from 'core/application/commons/config'

import QsehraLogo from '../assets/images/QSEHRA.svg'
import PerksLogo from '../assets/images/Stipends.svg'
import GroupHRALogo from '../assets/images/group-hra-ver-2.svg'
import IchraLogo from '../assets/images/ichra-logo.svg'
import PeopleKeepLogo from '../assets/images/people-keep-benefits-personalized.svg'
import useUrlQueryParam from '../common/hooks/useUrlQueryParam'

interface AccountHeaderProps {
  styled?: boolean
  eeSignUp?: number
  onlyMainLogo?: boolean
}

const AccountHeader: React.FC<AccountHeaderProps> = (props) => {
  const productId = parseInt(useUrlQueryParam('productId'))
  const { onlyMainLogo = false } = props

  const getLogo = () => {
    switch (productId) {
      case ProductIds.QsehraId:
        return QsehraLogo
      case ProductIds.Perks:
        return PerksLogo
      case ProductIds.IchraId:
        return IchraLogo
      default:
        return GroupHRALogo
    }
  }

  return (
    <Row>
      <Col>
        <img src={PeopleKeepLogo} alt="peoplekeep-logo" />
      </Col>

      {!onlyMainLogo && (
        <Col>
          <Divider type="vertical" style={{ height: '100%' }} />
        </Col>
      )}

      {!onlyMainLogo && (
        <Col className="">
          <img src={getLogo()} alt="peoplekeep-logo" />
        </Col>
      )}
    </Row>
  )
}

export default AccountHeader
